import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons';
import {USER_EVENT} from './constants';
import {UserActionLabel} from '../locales';

export const userActionNotificationsIcon = faPaperPlane;

/**
 * Route to user notifications
 * @param params
 * @returns Action
 */
export const userActionNotifications = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-notifications',
	cb: () => dispatcher.trigger(USER_EVENT.NOTIFICATIONS),
	icon: userActionNotificationsIcon,
	get label() {
		return UserActionLabel.NOTIFICATIONS;
	},
	...params,
});

export default userActionNotifications;
